import CipCleaningCard from "./CipCleaningCard";
import CipPredictionCard from "./CipPredictionCard";
import MembranePredictionCard from "./MembranePredictionCard";
import SmartInsightCard from "./smartInsightCard";

export const ActiveInsightsCards = {
  Insights: SmartInsightCard,
  Prediction: CipPredictionCard,
  Cleaning: CipCleaningCard,
  MembranePrediction: MembranePredictionCard
};
